<template>
  <div class="check" v-if="sal">
    <p>
      Pass choisi : <strong> {{ sal.product.name }} </strong><br />
      Montant : <strong>{{ formattedPrice }}</strong
      ><br />
      Référence à joindre : <strong>{{ sal.ref }}</strong>
    </p>
    <h3>Paiement par chèque</h3>
    <p>
      Merci d'adresser votre chèque ou votre mandat postal à l'ordre suivant :
      <strong>{{ $store.state.siteConst.addressName }}</strong>
    </p>
    <p>
      Puis envoyez celui-ci à l'adresse suivante :
    </p>
    <p>
      <strong>
        {{ $store.state.siteConst.addressName }} <br />
        14 rue Merlin de Thionville <br />
        92150, Suresnes <br />
        <br />
      </strong>
      N'oubliez pas de notifier dans votre courrier
      <strong>votre adresse email ou votre pseudo sur Idylive</strong> ainsi que le numéro de référence suivant :
      <strong>{{ sal.ref }} </strong>
    </p>

    <p>
      Votre abonnement sera activé dés réception du chèque. Il sera prolongé automatiquement si vous avez déjà un
      abonnement en cours, aucun jour ne sera perdu.
    </p>

    <h3>Paiement par virement bancaire</h3>
    <p>
      Si vous souhaitez régler par virement bancaire, merci de nous contacter en cliquant sur le lien suivant :
      <router-link class="pinkLink" :to="{ name: 'Contact', params: { sujet: 'Paiement par virement bancaire' } }"
        >Contacter {{ $store.state.siteConst.name }}</router-link
      >
    </p>

    <div class="sereniteCheque" v-if="sal.product.type === 0">
      <h4>
        Pour seulement {{ montantSerenite }} EUR de plus : l'<strong
          ><span class="serenite">Pass Sérénité</span></strong
        >
        vous permet de rencontrer les membres que vous choisissez !
      </h4>

      <img class="iconesSerenite" src="/assets/icons/petitfiltre.png" />Etre contacté(e) par les membres qui vous
      plaisent : sexe, âge, région... <br />

      <img class="iconesSerenite" src="/assets/icons/spy.png" />Visualiser la date de dernière connexion des différents
      membres. <br />

      <img class="iconesSerenite" src="/assets/icons/ar.png" />Etre informé(e) de la réception de votre message par
      votre interlocuteur. <br />

      <img class="iconesSerenite" src="/assets/icons/disconnected.png" />Etre invisible sur le site, tout en pouvant
      communiquer avec les membres que vous choisissez. <br /><br />
      <p>
        <strong>
          Les fonctionnalités Filtre de contact et mode invisible sont accessibles dans le menu : Mon Compte /
          Confidentialité
        </strong>
      </p>

      La durée de l'<strong><span class="serenite">Pass Sérénité</span></strong> est couplée à celle de votre
      {{ sal.product.name }}. <br />
      La date d'échéance de l'<strong><span class="serenite">Pass Sérénité</span></strong> correspond à celle de votre
      <strong>Pass Idy<span class="pinklive">live</span></strong
      >. <br /><br />
      Montant total : <strong> {{ montantSereniteTotal }} EUR </strong>
    </div>

    <br />

    Merci de votre confiance ! <br />
    <br />

    L'équipe {{ $store.state.siteConst.name }}.
  </div>
</template>

<script>
import BasePage from "@/components/pages/BasePage";
import { idyuFormatPrice } from "@/assets/js/idyu/util.js";
import { idyuJsonRpc } from "../../assets/js/idyu/connect";

export default {
  name: "Check",
  extends: BasePage,
  data: function() {
    return {
      sal: null
    };
  },

  methods: {
    async routeEnter(to) {
      const product = await idyuJsonRpc("getProduct", parseInt(to.query.id));
      const idSale = await idyuJsonRpc("createSales");
      this.sal = await idyuJsonRpc("initSales", idSale, "ch", product.id);
    }
  },

  computed: {
    montantSerenite() {
      if (this.sal.product.code == 0) return 5;
      else return 3.0 * this.sal.product.monthDuration;
    },
    formattedPrice() {
      return idyuFormatPrice(this.sal.price, this.sal.product.currency);
    },
    montantSereniteTotal() {
      return this.montantSerenite + this.sal.product.price;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

.check {
  background-color: white;
  border: $light_border;
  padding: 10px;
}

.sereniteCheque {
  border-width: 2px;
  border-color: green;
  border-style: solid;
  padding: 5px;

  h4 {
    margin-top: 0;
  }

  img {
    width: 25px;
    vertical-align: middle;
    margin-right: 10px;
  }
}
</style>
